export default __webpack_public_path__ + "static/media/worker.c84d53ac.png";